import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { MainTabs } from "../../components/tab";
import { useSalesModeContext } from "../../features/sales/contexts";
import { useGetDiningOptionsQuery, useGetStoreInfoQuery } from "../../features/sales/services";
import { ILinkTabProps } from "../../types/interfaces";
import styles from "./storeTabs.module.scss";

const StoreTabs = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isOrderingMode } = useSalesModeContext();

    const { pathname } = useLocation();
    const { orgId, storeId } = useParams();
    const pathnameSplit = pathname?.split("/");
    const currentRoute = pathnameSplit[pathnameSplit?.length - 1] || "";
    const isCreateStore = storeId === undefined;

    // Fetch store info to get store name
    const { data: storesData } = useGetStoreInfoQuery(
        orgId
            ? {
                  org_id: orgId,
                  page: 1,
                  limit: 100,
              }
            : { org_id: "", page: 1, limit: 100 }
    );

    // Fetch dining options to get chat mode
    const { data: diningOptionsData } = useGetDiningOptionsQuery(
        storeId
            ? {
                  store_id: storeId,
              }
            : { store_id: "" }
    );

    const currentStore = storesData?.data?.result?.find((store) => store.id === storeId);
    const chatMode = diningOptionsData?.data?.chat_mode;
    const modeText =
        chatMode === "featured_recommendations"
            ? t("SALES.FeaturedRecommendations") || "展場模式"
            : t("SALES.OrderFlow") || "點餐模式";

    // Determine if current store is in exhibition mode (featured_recommendations)
    // const isExhibitionMode = chatMode === "featured_recommendations";

    const prodRoute = isOrderingMode
        ? [
              // { labelKey: "SALES.StoreSetting", href: `${isCreateStore ? "create" : "edit"}` },
              { labelKey: "SALES.BranchAdventureSettings", href: "card-settings" },
              //   { labelKey: "SALES.LinePaySettings", href: "linepay-settings", hideInExhibition: true },
              //   { labelKey: "SALES.TableManage", href: "table-management", hideInExhibition: true },
              //   { labelKey: "SALES.OrderList", href: "orders", hideInExhibition: true },
              // { labelKey: "SALES.ImportItems", href: "import-items" }, // Hidden: Under development
              //   { labelKey: "SALES.DeviceManagement", href: "device-management" },
              { labelKey: "SALES.ConfigSettings", href: "config" },
              // { labelKey: "SALES.SearchTestTool", href: "search-test-tool" }, // Hidden: Under development
          ]
        : [
              { labelKey: "SALES.BranchAdventureSettings", href: "card-settings" },
              //   { labelKey: "SALES.DeviceManagement", href: "device-management" },
              { labelKey: "SALES.ConfigSettings", href: "config" },
          ];

    // Filter routes based on exhibition mode
    // const filteredRoutes = prodRoute.filter((route) => {
    //     // If in exhibition mode and route has hideInExhibition flag, hide it
    //     if (isExhibitionMode) {
    //         return false;
    //     }
    //     return true;
    // });

    const filteredRoutes = prodRoute;

    // 在測試環境中顯示Config Settings
    const tabRoutes: ILinkTabProps[] = filteredRoutes;

    const [currentTab, setCurrentTab] = useState(0);

    const findIdx = tabRoutes.findIndex((r) => r.href === currentRoute);

    const handleChange = (newValue: number) => {
        setCurrentTab(newValue);
    };

    useEffect(() => {
        // if findIdx is not -1, means it's project dashboard index page, show current tab === Dashboard
        if (findIdx !== -1) {
            setCurrentTab(findIdx);
            return;
        }
        setCurrentTab(0);
    }, [findIdx, currentRoute]);
    return (
        <div className={styles.storeTabsWrapper}>
            {!isCreateStore && currentStore && (
                <div className={styles.storeNameHeader}>
                    <span className={styles.storeNameLabel}>{t("SALES.CurrentStore") || "當前分店"}:</span>
                    <span className={styles.storeName}>{currentStore.store_name}</span>
                    {chatMode && <span className={styles.storeMode}>({modeText})</span>}
                </div>
            )}
            <MainTabs
                isDisabled={isCreateStore}
                currentTab={currentTab}
                handleChange={handleChange}
                tabsOnClick={(tabRoute) => {
                    if (tabRoute.initHref) {
                        navigate(`/org/${orgId}/store/${storeId}/${tabRoute.initHref}`);
                    } else if (tabRoute.initHref === "") {
                        navigate(`/org/${orgId}/store/${storeId}`);
                    } else {
                        navigate(`/org/${orgId}/store/${storeId}/${tabRoute.href}`);
                    }
                }}
                tabRoutes={tabRoutes}
                isPill={true}
            />
        </div>
    );
};

export default StoreTabs;
